import { data } from './mock-data'

const onInitialize = async ({ state, actions, effects }, overmind) => {
  // const dataform = await effects.form.getForm()
  // const hiddenItem = dataform.map(item)
  state.form.data = data
  actions.form.getValuesFromServer()

  overmind.addMutationListener(mutation => {
    const args = mutation.args?.[0]
    if (args === undefined) return null
    if (mutation.path !== 'form.type') return null

    actions.form.setFormType({ formIdx: 0, typeIdx: args })
    actions.form.pushStepToForm()
  })
  return null
}

export default onInitialize
